import { DEV_ENDPOINT, AUTH_DOMAIN, LOCAL_REDIRECT } from '../common/constantsConfig';
export default {
	cognito: {
		REGION: 'us-east-1',
		USER_POOL_ID: 'us-east-1_Komn0qa8p',
		APP_CLIENT_ID: '3658tn76lfeejti6ocjkln40vk',
		IDENTITY_POOL_ID: 'us-east-1:1be336d8-0543-4bd3-9349-8a1bee50767a'
	},
	endpoints: [			
		{
			name: 'vendorbrokerui',
			endpoint: DEV_ENDPOINT,
			service: "lambda",
			region: "us-east-1"
		}
	],
	oauth:{
		// Domain name
		domain: AUTH_DOMAIN,
	
		// Authorized scopes
		scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
	
		// Callback URL
		redirectSignIn: LOCAL_REDIRECT, // or 'exp://127.0.0.1:19000/--/', 'myapp://main/'
	
		// Sign out URL
		redirectSignOut: LOCAL_REDIRECT, // or 'exp://127.0.0.1:19000/--/', 'myapp://main/'
	
		// 'code' for Authorization code grant, 
		// 'token' for Implicit grant
		// Note that REFRESH token will only be generated when the responseType is code
		responseType: 'token',
	
		// optional, for Cognito hosted ui specified options
		options: {
			// Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
			AdvancedSecurityDataCollectionFlag: true
		},
	
		urlOpener: null
	}

};
